import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { getStatus } from '../api/global-api';

import niftyLogo from '../images/nifty-logo.svg';

const STATUS_CHECK_INTERVAL = 1000 * 60 * .5; // 30 secs

export default class Maintenance extends PureComponent {
    static contextTypes = {
        router: PropTypes.object
    }

    getContent() {
        const locationState = this.context.router.getCurrentLocation().state;
        let code;

        code = locationState && locationState.code;

        switch (code) {
            case 440:
                return <p>Nifty is currently undergoing a scheduled maintenance and will be back up within an hour. Thanks for your patience!</p>;

            case 520:
                return <p>Your current app version is no longer supported. Please update your app to the latest version to continue using Nifty.</p>;

            default:
                return <p>Nifty is currently undergoing maintenance and will be back up shortly.</p>;
        }
    }

    hasAccessRequest(token, teamUrl) {
        getStatus()
            .then(response => {
                this.context.router.push({
                    pathname: `/dashboard`
                });
            });
    }

    componentDidMount() {
        this.hasAccessRequest();
        this.interval = setInterval(() => {
            this.hasAccessRequest();
        }, STATUS_CHECK_INTERVAL);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <div className="maintenance">
                <div className="maintenance-inner">
                    <img className="logo" src={niftyLogo} width="150px" alt="Nifty logo" />

                    {this.getContent()}

                    <p>-The Nifty Team</p>
                </div>
            </div>
        );
    }
};
